import { Flex, NumberInput, Text, TextInput, Title } from '@mantine/core';
import { AssetType } from '../../../../../backend/src/types.generated';
import { EditFormData } from './types';

interface ScanDetailsSectionProps {
	formData: EditFormData;
	onInput: (key: keyof EditFormData, value: string | number | null) => void;
	assetType: AssetType | null | undefined;
}

/**
 * Load details form section
 */
export const ScanDetailsSection: React.FC<ScanDetailsSectionProps> = ({
	formData,
	onInput,
	assetType,
}) => {
	return (
		<Flex direction="column" w="100%" gap="sm">
			<Flex px="md" align="center" justify="space-between" w="100%">
				<Title order={2}>{assetType === AssetType.Load ? 'Load' : 'Audit'} Details</Title>
			</Flex>

			<Flex direction="column" px="md" gap="md">
				{formData.docketId !== null && (
					<TextInput
						size="md"
						label="Docket ID"
						value={formData.docketId || ''}
						onChange={(e) => onInput('docketId', e.target.value)}
						placeholder="Enter docket ID"
					/>
				)}

				<Flex gap="md">
					{assetType === AssetType.Load ? (
						<NumberInput
							size="md"
							label="Load Weight"
							value={formData.weight ? (formData.weight / 1000).toString() : ''}
							onChange={(value) => {
								const numValue = typeof value === 'string' ? parseFloat(value || '0') : value || 0;
								onInput('weight', numValue * 1000);
							}}
							placeholder="0"
							rightSection={
								<Text size="sm" c="var(--mantine-color-grey-5)" pr="xl">
									Tonne
								</Text>
							}
							w="100%"
						/>
					) : (
						<NumberInput
							size="md"
							label="Bag Weight"
							value={formData.weight ? formData.weight.toString() : ''}
							onChange={(value) => {
								const numValue = typeof value === 'string' ? parseFloat(value || '0') : value || 0;
								if (typeof numValue === 'number') {
									onInput('weight', numValue);
								}
							}}
							placeholder="0"
							rightSection={
								<Text size="sm" c="var(--mantine-color-grey-5)" pr="xl">
									KG
								</Text>
							}
							w="100%"
						/>
					)}

					{formData.truckRegistration !== null && (
						<TextInput
							value={formData.truckRegistration || ''}
							onChange={(e) => onInput('truckRegistration', e.target.value)}
							size="md"
							label="Truck Registration"
							placeholder="ABC-123"
							w="100%"
						/>
					)}
				</Flex>
			</Flex>
		</Flex>
	);
};
